// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  BusinessStory,
  FinancialConnections,
  Property,
  OperatingLocations,
  UnderwritingResult,
  CardEngineShareableBusinessCardRow,
  CardEngineScheduledCallRow,
} from "./types";


export default __t.row({
  underwritableEntityId: __t.uuid().name("underwritable_entity_id"),
  get businessStory() {
    return BusinessStory.name("business_story");
  },
  get financialConnections() {
    return FinancialConnections.name("financial_connections");
  },
  get properties() {
    return __t.array(Property);
  },
  get operatingLocations() {
    return OperatingLocations.name("operating_locations");
  },
  get underwritingResults() {
    return __t.array(UnderwritingResult).name("underwriting_results");
  },
  get shareableBusinessCards() {
    return __t.array(CardEngineShareableBusinessCardRow).name("shareable_business_cards");
  },
  get scheduledCalls() {
    return __t.array(CardEngineScheduledCallRow).name("scheduled_calls");
  },
});
